/* eslint no-unused-vars: "off" */
/* eslint react/require-default-props: "off" */
import React, { useContext, useState } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { CardType, AnalyticEvents } from '../../constants';
import { ActiveLoanCard, PaidOffLoanCard } from './LoanSummaryCardTypes';

type MFEProps = {
  environment: any;
  feedData: {};
  positionValue?: number;
};

const LoanSummaryCard = ({ environment, feedData, positionValue }: MFEProps) => {
  const { trackEvent } = useContext(AnalyticsContext) as any;
  const [cardPosition] = useState(positionValue || 0);
  const { type }: any = feedData;
  const {
    id: cardId,
    callToAction: { link },
  }: any = feedData;

  // Redirect to my-cars
  const handleRedirect = () => {
    trackEvent(AnalyticEvents.ovpCardClicked, {
      cardId,
      cardPosition,
    });
    datadogRum.addAction(AnalyticEvents.ovpCardClicked, {
      cardId,
      cardPosition,
    });
    // Note: ths is valid window navigation when within a webview! Not Native Event needed
    window.location.href = link;
  };

  const captureImpression = () => {
    setTimeout(() => {
      trackEvent(AnalyticEvents.viewedOvpCardImpression, {
        cardId,
        cardPosition,
      });
      datadogRum.addAction(AnalyticEvents.viewedOvpCardImpression, {
        cardId,
        cardPosition,
      });
    }, 1000);
  };
  const { ref } = useIntersectionObserver({
    freezeOnceVisible: true,
    threshold: 0.5,
    onChange: (isIntersecting) => {
      if (isIntersecting && captureImpression) captureImpression();
    },
  });

  return (
    <>
      {type === CardType.LOAN_PAID_OFF ? (
        <PaidOffLoanCard environment={environment} feedData={feedData} handleRedirect={handleRedirect} ref={ref} />
      ) : (
        <ActiveLoanCard environment={environment} feedData={feedData} handleRedirect={handleRedirect} ref={ref} />
      )}
    </>
  );
};

export default LoanSummaryCard;
